export const useNavMenuFilter = ( {
                             user,
                             defaultUserGroup
                           } ) => {

  const filterMenuItems = ( items ) => {
    return items.filter(menuItem => {
      if( menuItem.subMenuitems && menuItem.subMenuitems.length > 0 ) {
        menuItem.subMenuitems = filterMenuItems(menuItem.subMenuitems);
      }
      if( menuItem.restrictUserGroups ) {
        if( user && user.userGroups ) {
          return user.userGroups.some(group => menuItem.userGroups.includes(group));
        } else if( !user && defaultUserGroup ) {
          return menuItem.userGroups.includes(defaultUserGroup?._id);
        }
        return false;
      }
      return true;
    });
  };

  return {
    filterMenuItems
  };

}